import React, { Component } from "react";
import ReactPlayer from "react-player/lazy";
import PdfPopupViewer from "../../PdfPopupViewer/PdfPopupViewer";

/**
 * Renders the media the server resolved for this user (the per-country variant is already
 * picked server-side, so `media.url` is shown exactly as given):
 *   image      -> <img>
 *   pdf        -> PdfPopupViewer (in-page, links open in a new tab)
 *   video_file / video_link -> ReactPlayer, controls on, download disabled (DPAForm pattern)
 *
 * must_watch: onWatched() fires exactly once, either when the video ends or once progress
 * reaches (duration - 2) seconds — the same "watched to the end" rule as the DPA video.
 */

// Seconds before the end at which a video counts as watched (the last frames are often cut by
// the player's own end handling, so waiting for exactly `duration` can miss the mark).
const WATCHED_TOLERANCE_SECONDS = 2;

class MediaRenderer extends Component {
  duration = null;
  watchedReported = false;

  reportWatched = () => {
    if (this.watchedReported) return;
    this.watchedReported = true;
    if (typeof this.props.onWatched === "function") {
      this.props.onWatched();
    }
  };

  onDuration = (seconds) => {
    this.duration = seconds;
  };

  onProgress = ({ playedSeconds }) => {
    if (!this.props.media.must_watch || this.duration === null) return;
    if (playedSeconds >= this.duration - WATCHED_TOLERANCE_SECONDS) {
      this.reportWatched();
    }
  };

  onEnded = () => {
    if (!this.props.media.must_watch) return;
    this.reportWatched();
  };

  render() {
    const { media, title } = this.props;
    if (!media || !media.media_type) return null;

    switch (media.media_type) {
      case "image":
        return <img src={media.url} alt={title} className="broadcast-media-image" />;

      case "pdf":
        return <PdfPopupViewer src={media.url} title={title} />;

      case "video_file":
      case "video_link":
        return (
          <div className="broadcast-media-video">
            <ReactPlayer
              url={media.url}
              controls={true}
              width="100%"
              config={{ file: { attributes: { controlsList: "nodownload" } } }}
              onDuration={this.onDuration}
              onProgress={this.onProgress}
              onEnded={this.onEnded}
            />
          </div>
        );

      default:
        return null;
    }
  }
}

export default MediaRenderer;
